import { render, staticRenderFns } from "./AuthLoginThirdPartyButton.vue?vue&type=template&id=8c98baaa&"
import script from "./AuthLoginThirdPartyButton.vue?vue&type=script&lang=ts&"
export * from "./AuthLoginThirdPartyButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports